import { IBuilderModel } from '../models/workflow-builder.model';

export type WorkflowStateKind = 'normal' | 'final' | 'dead-end';

const FINAL_STATE_CODES = new Set([
  'APPROVED',
  'PUSHED_TO_PARTNER',
  'REJECTED',
  'PAYMENT_EXPIRED',
  'CANCELLED',
]);

export function isKnownFinalState(stateCode: string): boolean {
  return FINAL_STATE_CODES.has(stateCode.trim().toUpperCase());
}

export function classifyState(
  stateCode: string,
  model: IBuilderModel
): WorkflowStateKind {
  if (
    model.transitions.some(transition => transition.startState === stateCode)
  ) {
    return 'normal';
  }
  return isKnownFinalState(stateCode) ? 'final' : 'dead-end';
}
